import {
  Button,
  CircularLoader,
  Icon,
  Input,
  Textarea,
  Typography,
} from "@plum-xoxo/admin-dsm";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import theme from "../../theme";
import transactionService from "../../services/transactionService";
import { NotificationManager } from "react-notifications";
import { uploadRequest } from "../../utils/globals";

const WhatsApp = ({
  whatsappImage = "",
  whatsappText = "",
  whatsappAlbumImageId,
  updateState = () => {},
  site_id = 0,
  rewardType = 2,
}) => {
  const [displayImage, setDisplayImage] = useState();
  const [imageUploading, setImageUploading] = useState(false);
  const [error, setError] = useState("");
  let title = "";
  if (rewardType === 1) {
    title = (
      <>
        {"{"}no. of points{"}"} {"{"}reward title{"}"} have been successfully
        added to your account.
        <br />
        <br />
        You can view and redeem your {"{"}reward title{"}"} by clicking the
        button below. This code is valid until {"{"}validity{"}"}.
      </>
    );
  } else if (rewardType === 2) {
    title = (
      <>
        Your code {"{"}code{"}"} worth {"{"}currency_code{"}"} {"{"}amount_value
        {"}"} has been successfully issued.
        <br />
        <br />
        Click the button below to redeem.
      </>
    );
  }
  const uploadFile = (event) => {
    if (event.target.files && event.target.files[0]) {
      let files = event.target.files;
      const reader = new FileReader();
      const inputElement = event.target;
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const aspectRatio = img.width / img.height;
          const requiredAspectRatio = 1.91;
          const aspectRatioError =
            Math.abs(aspectRatio - requiredAspectRatio) > 0.05;
          const sizeError = files[0].size > 200000;
          if (aspectRatioError && sizeError) {
            setError(
              "The image could not be uploaded due to invalid size and aspect ratio. Try again with recommended size and dimension."
            );
            return;
          } else if (sizeError) {
            setError(
              "The image could not be uploaded due to invalid size. Try again with recommended size."
            );
            return;
          } else if (aspectRatioError) {
            setError(
              "The image could not be uploaded due to invalid aspect ratio. Try again with recommended ratio."
            );
            return;
          }
          setError("");
          uploadTemplateImages(files);
          setDisplayImage(e.target.result);
          inputElement.value = "";
        };
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      NotificationManager.info(
        "Image size should be less than 300Kb",
        "Warning"
      );
    }
  };

  const uploadTemplateImages = (imgResp) => {
    setImageUploading(true);
    updateState({ isLoading: true });
    const formData = new FormData();
    formData.append("attachments", imgResp[0]);
    formData.append("site_id", site_id);
    formData.append("is_whatsapp", true);
    uploadRequest(
      formData,
      function (response) {
        if (
          response !== undefined &&
          response.error == false &&
          response.data[0]
        ) {
          setImageUploading(false);
          updateState({
            whatsappAlbumImageId: response.data?.[0]?.image_id,
            whatsappImage: response.data?.[0]?.image_url,
            isLoading: false,
          });
          NotificationManager.success(
            "Image uploaded successfully.",
            "success"
          );
        } else {
          NotificationManager.error(
            "Sorry, we could not upload this file. Try saving it in a different format and upload again",
            "Error"
          );
          setImageUploading(false);
          updateState({ loader: false });
        }
      }.bind(this),
      "/api/graph/uploadTemplateImages"
    );
  };

  const setDefaultImage = () => {
    transactionService.getCardImages({ all_category: 1 }).then((resp) => {
      const data = resp.fetchAlbumList.data;
      const image = data.find((img) => img.image_id === 1);
      setDisplayImage(image?.image_url || "");
      setImageUploading(false);
    });
  };

  useEffect(() => {
    setImageUploading(true);
    if (whatsappAlbumImageId > 0) {
      setDisplayImage(whatsappImage);
      setImageUploading(false);
    } else {
      setDefaultImage();
    }
  }, [whatsappAlbumImageId, whatsappImage]);

  return (
    <div>
      <Row>
        <Col xs={6}>
          <Typography.LabelText className="mb-8" color="dark" shade="c200">
            Banner
          </Typography.LabelText>

          <div
            className="p-20"
            style={{
              backgroundColor: theme.palette.light.c200,
              borderRadius: 4,
            }}
          >
            <input
              accept=".jpg, .jpeg"
              className="file d-none"
              id="whatsapp-image-file"
              type="file"
              onChange={uploadFile}
            />
            {displayImage && !imageUploading ? (
              <div className="d-flex align-items-center justify-content-between ">
                <div>
                  <img
                    src={displayImage}
                    alt=""
                    style={{
                      width: 128,
                      height: 68,
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div>
                  <label
                    htmlFor="whatsapp-image-file"
                    className="m-0 cursor-pointer"
                  >
                    <Typography
                      className="cursor-pointer m-0"
                      color="blue"
                      shade="c200"
                    >
                      Upload New
                    </Typography>
                  </label>
                </div>
              </div>
            ) : (
              <div>
                <label
                  htmlFor="whatsapp-image-file"
                  className="d-flex align-items-center justify-content-center m-0 cursor-pointer"
                >
                  {imageUploading ? (
                    <>
                      <CircularLoader size="lg" />
                    </>
                  ) : (
                    <>
                      <Icon
                        iconName="Plus"
                        size={18}
                        color="primary"
                        shade="c02"
                      />
                      <Typography.ButtonText
                        className="cursor-pointer ml-0"
                        color="blue"
                        shade="c200"
                      >
                        Add Banner
                      </Typography.ButtonText>
                    </>
                  )}
                </label>
              </div>
            )}
          </div>
          {error && (
            <Typography.HelperText className="my-8" color="red" shade="c200">
              {error}
            </Typography.HelperText>
          )}

          <Typography.HelperText
            className="mt-8 mb-20"
            color="base"
            shade="c05"
          >
            Aspect ration: 1.91:1. Maximum Size: 2MB. Accepted format: JPEG or
            JPG
          </Typography.HelperText>

          <Textarea
            style={{
              backgroundColor: theme.palette.common.white,
            }}
            label="Message"
            onBlur={() => {}}
            onChange={(e) => {
              updateState({ whatsappText: e.target.value });
            }}
            limit={90}
            value={whatsappText}
          />
        </Col>
        <Col xs={6}>
          <Typography.LabelText className="mb-4" color="dark" shade="c200">
            Preview
          </Typography.LabelText>
          <div
            className="py-40 d-flex justify-content-center"
            style={{
              backgroundColor: theme.palette.light.c100,
              border: `1px solid ${theme.palette.light.c300}`,
              fontFamily: "Roboto",
            }}
          >
            <div className="position-relative mx-auto">
              <img
                style={{ width: 270 }}
                src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1740047655/store/admin/whatsapp-chat-bg.jpg"
                alt=""
              />
              <div
                className="position-absolute whatsapp-scrollbar"
                style={{
                  width: 262,
                  top: 64,
                  left: 8,
                  overflowY: "auto",
                  maxHeight: 448,
                }}
              >
                <div
                  className="p-6 bg-white mt-16"
                  style={{
                    width: 212,
                    borderRadius: 4,
                  }}
                >
                  {displayImage && !imageUploading ? (
                    <img
                      src={displayImage}
                      alt=""
                      style={{
                        width: "100%",
                      }}
                    />
                  ) : (
                    ""
                  )}

                  <div
                    className="mt-4"
                    style={{
                      fontSize: "12px",
                      color: theme.palette.common.black,
                      lineHeight: "14px",
                    }}
                  >
                    Hey {"{"}username{"}"},
                    <br />
                    <br />
                    <span
                      style={{
                        fontWeight: 700,
                        wordWrap: "break-word",
                      }}
                    >
                      * {whatsappText} *
                    </span>
                    {title}
                    <br />
                    <br />
                    Powered by Xoxoday 🚀.
                  </div>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center p-6 mt-3 bg-white"
                  style={{
                    width: 212,
                    borderRadius: 4,
                  }}
                >
                  <Icon
                    iconName="PlumLink"
                    onClick={() => {}}
                    color="#0096DE"
                    size={12}
                  />
                  <div
                    style={{
                      color: "#0096DE",
                      fontSize: 12,
                    }}
                    className="ml-4"
                  >
                    Visit Website
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default WhatsApp;
